import Layout from "@/views/Layout.vue";

const router = [
  {
    path: "/product", //公司产品
    name: "product",
    component: () => import("@/views/product/Index.vue"),
  },
  {
    path: "/product/detail/:id?", //公司产品详情
    name: "product-detail",
    component: () => import("@/views/product/Detail.vue"),
  },
];
const routerItem = {
  path: "/",
  redirect: "/product",
  component: Layout,
  children: router,
};

export default routerItem;
